import { useApiLazyQuery } from '@common/hooks';
import { getEntityAuditTrailById } from '@common/services';
import {
  GetEntityAuditTrailByIdResponse,
  GetEntityAuditTrailByIdVariables
} from '@common/types';

const useGetAuditTrailById = () =>
  useApiLazyQuery<
    GetEntityAuditTrailByIdResponse,
    GetEntityAuditTrailByIdVariables
  >(
    getEntityAuditTrailById,
    'getEntityAuditTrailById',
    {
      fetchPolicy: 'cache-and-network'
    },
    {
      withLoader: false
    }
  );

export { useGetAuditTrailById };
